import React from 'react';
import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

interface InfoPopoverProps {
  label: string;
  children: React.ReactNode;
}

const InfoPopover: React.FC<InfoPopoverProps> = ({ label, children }) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={label}
          className="p-1 rounded-full text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <Info className="h-5 w-5" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 max-w-[calc(100vw-2rem)]" align="start">
        <div className="text-sm space-y-2">{children}</div>
      </PopoverContent>
    </Popover>
  );
};

export default InfoPopover;
